import { render, staticRenderFns } from "./athlete-registration-print.vue?vue&type=template&id=5bad7d79&scoped=true&"
import script from "./athlete-registration-print.vue?vue&type=script&lang=js&"
export * from "./athlete-registration-print.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bad7d79",
  null
  
)

export default component.exports